<app-network-indicator></app-network-indicator>

<app-header></app-header>
<div class="min">
  <ngx-loading-bar [height]="'8px'" [color]="'#07ab3e'"></ngx-loading-bar>

  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<app-footer></app-footer>
